var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeclined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.554 45.654C28.4747 45.654 30.8424 43.2863 30.8424 40.3656C30.8424 37.4448 28.4747 35.0771 25.554 35.0771C22.6333 35.0771 20.2656 37.4448 20.2656 40.3656C20.2656 43.2863 22.6333 45.654 25.554 45.654Z",
    fill: "#F44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5525 37.6256C32.2176 37.6256 37.6207 32.2225 37.6207 25.5574C37.6207 18.8924 32.2176 13.4893 25.5525 13.4893C18.8875 13.4893 13.4844 18.8924 13.4844 25.5574C13.4844 32.2225 18.8875 37.6256 25.5525 37.6256Z",
    fill: "#F44336"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.554 16.0387C28.4747 16.0387 30.8424 13.671 30.8424 10.7503C30.8424 7.82962 28.4747 5.46191 25.554 5.46191C22.6333 5.46191 20.2656 7.82962 20.2656 10.7503C20.2656 13.671 22.6333 16.0387 25.554 16.0387Z",
    fill: "#F44336"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9564 43.6657C35.8771 43.6657 38.2448 41.298 38.2448 38.3773C38.2448 35.4566 35.8771 33.0889 32.9564 33.0889C30.0357 33.0889 27.668 35.4566 27.668 38.3773C27.668 41.298 30.0357 43.6657 32.9564 43.6657Z",
    fill: "#F44336"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1478 18.027C21.0685 18.027 23.4362 15.6593 23.4362 12.7386C23.4362 9.8179 21.0685 7.4502 18.1478 7.4502C15.2271 7.4502 12.8594 9.8179 12.8594 12.7386C12.8594 15.6593 15.2271 18.027 18.1478 18.027Z",
    fill: "#F44336"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3743 38.2497C41.2951 38.2497 43.6628 35.882 43.6628 32.9613C43.6628 30.0406 41.2951 27.6729 38.3743 27.6729C35.4536 27.6729 33.0859 30.0406 33.0859 32.9613C33.0859 35.882 35.4536 38.2497 38.3743 38.2497Z",
    fill: "#F44336"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7337 23.4421C15.6544 23.4421 18.0221 21.0744 18.0221 18.1536C18.0221 15.2329 15.6544 12.8652 12.7337 12.8652C9.81301 12.8652 7.44531 15.2329 7.44531 18.1536C7.44531 21.0744 9.81301 23.4421 12.7337 23.4421Z",
    fill: "#F44336"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3587 30.8463C43.2794 30.8463 45.6471 28.4786 45.6471 25.5579C45.6471 22.6372 43.2794 20.2695 40.3587 20.2695C37.438 20.2695 35.0703 22.6372 35.0703 25.5579C35.0703 28.4786 37.438 30.8463 40.3587 30.8463Z",
    fill: "#F44336"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7454 30.8463C13.6661 30.8463 16.0338 28.4786 16.0338 25.5579C16.0338 22.6372 13.6661 20.2695 10.7454 20.2695C7.82473 20.2695 5.45703 22.6372 5.45703 25.5579C5.45703 28.4786 7.82473 30.8463 10.7454 30.8463Z",
    fill: "#F44336"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3743 23.4421C41.2951 23.4421 43.6628 21.0744 43.6628 18.1536C43.6628 15.2329 41.2951 12.8652 38.3743 12.8652C35.4536 12.8652 33.0859 15.2329 33.0859 18.1536C33.0859 21.0744 35.4536 23.4421 38.3743 23.4421Z",
    fill: "#F44336"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7337 38.2497C15.6544 38.2497 18.0221 35.882 18.0221 32.9613C18.0221 30.0406 15.6544 27.6729 12.7337 27.6729C9.81301 27.6729 7.44531 30.0406 7.44531 32.9613C7.44531 35.882 9.81301 38.2497 12.7337 38.2497Z",
    fill: "#F44336"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9564 18.027C35.8771 18.027 38.2448 15.6593 38.2448 12.7386C38.2448 9.8179 35.8771 7.4502 32.9564 7.4502C30.0357 7.4502 27.668 9.8179 27.668 12.7386C27.668 15.6593 30.0357 18.027 32.9564 18.027Z",
    fill: "#F44336"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1478 43.6657C21.0685 43.6657 23.4362 41.298 23.4362 38.3773C23.4362 35.4566 21.0685 33.0889 18.1478 33.0889C15.2271 33.0889 12.8594 35.4566 12.8594 38.3773C12.8594 41.298 15.2271 43.6657 18.1478 43.6657Z",
    fill: "#F44336"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6484 31.4629L31.4538 16.6576L34.4449 19.6487L19.6396 34.454L16.6484 31.4629Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6484 19.6514L19.6396 16.6602L34.4449 31.4656L31.4538 34.4567L16.6484 19.6514Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclined);
export default __webpack_public_path__ + "static/media/declined.013bee98fef15984c54bef60e14ff417.svg";
export { ForwardRef as ReactComponent };